<div class="container-fluid py-5">
    <div class="col-md-8 cah-signup-card offset-0 offset-md-2 offset-lg-2 offset-md-0  mt-0 mt-lg-5">
        <div class="d-flex">
            <div class="cah-signup-sec px-0 shadow d-lg-block d-none d-sm-none">
                <div class="py-5 cah-p-lr-40 text-white">
                    <h1 class="fw-bolder cah-font-35 mb-4">{{displayUserType}} <br>Password Reset</h1>
                    <p class="cah-font-16 mb-5">Get access to your account</p>
                    <div class="text-center py-5"><img src="{{assets}}img/auth/speci-graphic-left.png"></div>
                </div>
            </div>
            <div class="w-100 px-0">
                <form [formGroup]="form" >
                    <div class="w-100 cah-sign-up-step">
                        <div class="pt-5 px-5">
                            <p class="cah-font-16">Reset your account password</p>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>New Password</mat-label>
                                    <input 
                                    [type]="hide ? 'password' : 'text'"
                                    (keydown.space)="$event.preventDefault();" 
                                     maxlength="16"
                                     (keyup)="checkPassword()" 
                                    formControlName="password" 
                                    matInput required>
                                    <button  mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button" (click)="hide = !hide">
                                        <mat-icon *ngIf="!hide">visibility</mat-icon>
                                    <mat-icon *ngIf="hide">visibility_off</mat-icon>
                                      </button> 
                                </mat-form-field>
                                <div class="message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['password'].hasError('required') && form.controls['password'].touched"
                                        >
                                        {{message.error[27]}}
                                    </div>
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['password'].hasError('pattern') && form.controls['password'].touched"
                                        >
                                        {{message.error[18]}}
                                    </div>
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['password'].hasError('whitespace') && form.controls['password'].touched"
                                        >
                                        {{message.error[29]}}
                                    </div>
                                </div>
                                </div>
                                <div class="field-content">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Confirm Your Password</mat-label>
                                        <input 
                                        [type]="chide ? 'password' : 'text'"
                                        (keydown.space)="$event.preventDefault();" 
                                         maxlength="16"
                                        formControlName="confirmPassword" 
                                        matInput 
                                        required>
                                        <button  mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button" (click)="chide = !chide">
                                            <mat-icon *ngIf="!chide">visibility</mat-icon>
                                        <mat-icon *ngIf="chide">visibility_off</mat-icon>
                                          </button> 
                                    </mat-form-field>
                                    <div class="message-block">
                                        <div class="mat-error error-message"
                                            *ngIf="form.controls['confirmPassword'].hasError('required') && form.controls['confirmPassword'].touched"
                                            >
                                            {{message.error[28]}}
                                        </div>
                                        <div class="mat-error error-message"
                                            *ngIf="form.controls['confirmPassword'].hasError('passwordCompare')"
                                          >
                                            {{message.error[16]}}
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-4">
                                    <div>
                                        <mat-checkbox 
                                        #lowerCase 
                                        [disabled]= true
                                        class="cah-pointer-none example-margin" 
                                        name="pass-validation" color="Primary" required>At least 1 lower case character</mat-checkbox>
                                    </div>
                                    <div>
                                        <mat-checkbox 
                                        #upperCase 
                                        [disabled]= true
                                         class="cah-pointer-none example-margin" 
                                         name="pass-validation" 
                                         color="Primary" >At least 1 upper case character</mat-checkbox>
                                    </div>
                                    <div>
                                        <mat-checkbox 
                                         class="cah-pointer-none example-margin"
                                         #oneNumeric 
                                         [disabled]= true
                                          name="pass-validation" 
                                          color="Primary" 
                                          >At least 1 numeric character</mat-checkbox>
                                    </div>
                                    <div>
                                        <mat-checkbox 
                                        #symbol
                                        [disabled]= true
                                        class="example-margin" 
                                        color="Primary">Atleast 1 symbol</mat-checkbox>
                                    </div>
                                    <div>
                                        <mat-checkbox 
                                        #minLength 
                                        [disabled]= true
                                        class="cah-pointer-none example-margin" 
                                        name="pass-validation" 
                                        color="Primary" >Minimum 8 characters long</mat-checkbox>
                                    </div>
                                </div>
                        </div>
                        <div class="px-5">
                            <button 
                            [disabled]="!form.valid" 
                            (click)="resetPasword()"
                            class="btn btn-violet btn-lg w-100 fs-5 h-60 mt-2">
                            Submit
                        </button>
                            
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>